import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateGrpAppPats } from '../../../redux/slices/scheduler/appointmentSlice';
import Button from '../../Button';
function GroupAppPatPopUp({ handleOpenPatSerch, handleGrpAppClose, styles }) {
  const dispatch = useDispatch();

  const { grpAppPats } = useSelector((store) => store.appointment);

  const removeParFromGrpApp = (patId) => {
    dispatch(updateGrpAppPats(patId));
  };

  const mystyle = {
    right: styles?.right,
  };
  return (
    <div className="main-contnr grp-appt-popup" style={mystyle}>
      <div className="flex-sec justify-between item-center clear-left10">
        <div className="hdr-pt-info">
          Patient(s) added in group: ({grpAppPats ? grpAppPats.length : 0})
          {handleOpenPatSerch && (
            <Link className="clear-left10" onClick={handleOpenPatSerch}>
              Add patient
            </Link>
          )}
        </div>
        <Button variant="circle" onClick={handleGrpAppClose}>
          X
        </Button>
        {/* <div className="close" onClick={handleGrpAppClose}>
          X
        </div> */}
      </div>
      <div className="main-contnr-bdy" style={{ height: '300px' }}>
        <ol>
          {grpAppPats &&
            grpAppPats.map((data, idx) => {
              return (
                <li
                  key={data?.userId}
                  className={
                    idx % 2 === 1 ? 'contnr-bdy-rw alt-rw' : 'contnr-bdy-rw'
                  }
                >
                  <span className="">
                    <span className="">
                      {data?.patName} (ID: {data?.chart_number})
                    </span>
                    <br />
                    <span className="sec-colr">
                      Prev. Enc. {data?.lastVisDt || 'N/A'}
                    </span>
                    <span className="red">&nbsp;|&nbsp;</span>
                    <span className="sec-colr">
                      {data?.lastVisTov || 'N/A'}
                    </span>
                    <span className="red">&nbsp;|&nbsp;</span>
                    <span className="sec-colr">
                      {data?.lastAppResName || 'N/A'}
                    </span>
                  </span>
                  <span
                    className="red right"
                    onClick={() => removeParFromGrpApp(data?.userId)}
                  >
                    &#10007;
                  </span>
                </li>
              );
            })}
        </ol>
      </div>
    </div>
  );
}

export default GroupAppPatPopUp;
